import { SelectGroup } from '#components/patterns/forms/select/select-group/SelectGroup.tsx';
import { SelectItem } from '#components/patterns/forms/select/select-item/SelectItem.tsx';
import { Select } from '#components/patterns/forms/select/select/Select.tsx';
import type { ClientInfo } from '#dn-types/downloads.ts';
import { ARCHITECTURES_POPULAR } from './package-install.ts';

type Props = {
  archOptions: ClientInfo[];
  arch?: string;
  onArchChange: (arch: string) => void;
  className?: string;
};

/** The architecture select for the Linux binary-download step, most popular arches first. */
export function LinuxArchSelect({ archOptions, arch, onArchChange, className }: Props) {
  return (
    <Select
      label="Architecture"
      className={className}
      // Controlled by the parent's arch state. This mounts with a non-empty value — the exact
      // scenario that crashed the old effect-synced Select and forced an uncontrolled workaround
      // here; ariakit's native controlled mode handles it, and onChange only fires for real
      // user selections.
      value={arch}
      onChange={onArchChange}
      renderValue={(value: string) => archOptions.find((a) => a.key === value)?.label ?? 'Please select…'}
    >
      <SelectGroup label="Popular" hasBottomBorder={true}>
        {archOptions
          .filter((a) => ARCHITECTURES_POPULAR.includes(a.key))
          .map((a) => (
            <SelectItem key={a.key} value={a.key}>
              {a.label}
            </SelectItem>
          ))}
      </SelectGroup>
      {archOptions
        .filter((a) => !ARCHITECTURES_POPULAR.includes(a.key))
        .map((a) => (
          <SelectItem key={a.key} value={a.key}>
            {a.label}
          </SelectItem>
        ))}
    </Select>
  );
}
